import { useEffect, useRef, useState, useMemo } from "react";
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import useDateEvents from "../../hooks/timeline/useDateEvents";

import useIsMobile from "../../hooks/useIsMobile";

import useAuth from "../../hooks/useAuth";

import { useCalendarContext } from "../../contexts/Calendar";

import useLocalStylistsStore from "../../store/stylists/local";

import { dimensions, mockEvents,
  TimelineTableHead,
  TimelineTableDateEventBar,
  TimelineSpacer,
  TimelineFullDateEventsContainer,
  TimelineLegalHolidays,
  TimelineJewishHolidays,
  TimelineIconContainer,
  TimelineTableBodyContainer,
  TimelineTrackHeader,
  TimelineTrackHeaderScroll,
  TimelineTableBody,
  TableTimelineDisplay,
  TimelineEventBoard,
  TimelineHoursColumn,
  TimelineRibbon,
  TimelineSeeker,
  TimelineTrack,
  TimelineTrackTitle,
  TimelineTableWeekBar,


  PrintTimelineEvents,
  // PrintTimelineDisplay,
  PrintTimelineDay,
  // PrintTimelineHours,
  PrintTimelineHebEvents,
  TimelineHeaderDay,
  WeekDayTrack
 } from "./Common";

 import PrintTimelineDisplay from "./Components/TimelineTile";
 import PrintTimelineHours from "./Components/TimelineHours";
 import TimelineContainer from "./Components/TimelineContainer";

import { getYPos, roundMinutesToNearestPoint, roundToPointOfHourTime, findEventInDate, constructDate, get3DayRange, getWeekDay } from './helpers';

import WatchLaterIcon from '@mui/icons-material/WatchLater';
import Timeline from "@mui/icons-material/Timeline";

const Container = styled.div`

`;

const WeekLine = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  

  & > div {
    flex-grow: 1;
    flex-basis: 0;
  }

  @media ${props => props.theme.breaks.down('md')} {
   overflow-x: scroll;
  }
`;


const ThreeDayComponent = ({hours = 24, divide = 2, curDate = {}, display = "vertical", children}) => {

  let activeStylists = useLocalStylistsStore(state => state.activeStylists);

  let { start, end } = useMemo(() => get3DayRange(curDate), [curDate])
  let { dates = [], scheduledEvents = [], dayOfWeek, fullDate, filterByStylist, filterByDay, filterHebEvents, workingHours, filterWorkingHours } = useDateEvents({start_date: start, end_date: end, range_type: '3day', stylists: activeStylists.filter(el => el.checked).map(el => el.stylist_id)})
  const { isMobile } = useIsMobile();

  const { setting } = useCalendarContext() || {};

  let { view_density, display_hours } = setting?.data || {};

  let rowHeight = +view_density || dimensions.timeline.hour.height;
  let beginShow = +display_hours?.start ? +display_hours?.start : 0;

  const { user } = useAuth();
  
  const [seekerPos, setSeekerPos] = useState(0);

  let curHour = new Date().getHours();
  let startHour = getYPos((curHour - beginShow), rowHeight);
  // let roundedTime = roundMinutesToNearestPoint(new Date());
  // let seekerPos = getYPos((curHour + (roundedTime / 100) - beginShow), rowHeight);

  useEffect(() => {
    const updateSeeker = () => {
      const time = new Date();
      const hour = time.getHours();
      const roundedTime = roundMinutesToNearestPoint(time, 1);
      setSeekerPos(getYPos((hour + (roundedTime / 100) - beginShow), rowHeight));
    };

    updateSeeker(); // run immediately on mount
    const id = setInterval(updateSeeker, 60 * 1000);
    return () => clearInterval(id);
  }, [beginShow, rowHeight]);


  const tableBodyRef = useRef(null);
  const trackHeaderRef = useRef(null);
  const timelineDisplayRef = useRef(null);
  const lastScrollX = useRef(0);

  const scrollHorizontal = (e) => {
    let scroll;
    
    if (e.deltaX !== undefined) {
      // Desktop wheel event
      scroll = e.deltaX;
    } else {
      // Mobile scroll event
      const currentScrollX = e.target.scrollLeft;
      scroll = currentScrollX - lastScrollX.current;
      lastScrollX.current = currentScrollX;
    }
    // console.log(scroll, "scroll", e);
    
    timelineDisplayRef.current.scrollBy({
      top: 0,
      left: scroll,
      // behavior: 'smooth'
    });
    
    trackHeaderRef.current.scrollBy({
      top: 0,
      left: scroll,
      // behavior: 'smooth'
    });
  };

  return (
    <Container>
       <TimelineTableHead>
        <TimelineRibbon>
          <TimelineIconContainer>
            <WatchLaterIcon fontSize={isMobile ? "small" : "large"} />
          </TimelineIconContainer>
          <WeekLine ref={trackHeaderRef} onScroll={scrollHorizontal}>
            {
              dates.map((day, i) => (
                <PrintTimelineDay key={getWeekDay(day)} day={getWeekDay(day)} dayOfMonth={day.getDate()} date={day} auto />
              ))
            }
          </WeekLine>
        </TimelineRibbon>
      </TimelineTableHead>
      <TimelineTableWeekBar>
        {dates.map((day, i) => (
          <TimelineTableDateEventBar key={getWeekDay(day)}>
          <TimelineFullDateEventsContainer $noPad={i !== 0}>
            <TimelineLegalHolidays>
            </TimelineLegalHolidays>
            <TimelineJewishHolidays>
              <PrintTimelineHebEvents date={day} />
            </TimelineJewishHolidays>
          </TimelineFullDateEventsContainer>
        </TimelineTableDateEventBar>
        ))}
      </TimelineTableWeekBar>
     

      <TimelineContainer>
        <TimelineTableBody>
          <TimelineHoursColumn>
            <PrintTimelineHours />
          </TimelineHoursColumn>

          <TableTimelineDisplay $columns={dates.length} ref={timelineDisplayRef}>
            <TimelineSeeker pos={seekerPos} /> {/* Seeker to show current time */}
            {dates.map((day, i) => {
              let filtered = filterByDay(day, scheduledEvents);
              // if (user?.stylist_id) {
              //   filtered = filterByStylist(user.stylist_id, filtered);
              // }
              let weekDay = getWeekDay(day);
              return (
                <WeekDayTrack key={weekDay}>
                  <TimelineEventBoard
                    id={`timeline${weekDay}`}
                  >
                    <PrintTimelineEvents events={filtered} track={`timeline${weekDay}`} />
                    
                  </TimelineEventBoard>

                  <PrintTimelineDisplay 
                    hours={hours} 
                    track={i} 
                    workingHours={filterWorkingHours(workingHours, null, getWeekDay(day, "long"))} 
                    date={day}
                    id={`timeline${weekDay}`}
                    stylist={user?.stylist_id}
                  />
                </WeekDayTrack>
              )
            })}
          
          </TableTimelineDisplay>
        </TimelineTableBody>
      </TimelineContainer>
    </Container>
  )
};

export default ThreeDayComponent;